import { ISessionStrategy } from 'src/types/module_types_authentication';
import { ISessionModuleConfiguration } from 'src/modules/session_module';
import { CookieServant } from 'src/servants/cookie_servant';
import { IHIHTTP } from 'src/types/hip_types';
import { Hosting } from 'src/core/ahp';

export class TokenCookieSessionStrategy implements ISessionStrategy {
  deactivate(ahp: Hosting) {
    // can we unhijack? hijack needs to give us a token of the previous function
    // issue: other methods could have been added since then
  }

  activate(ahp: Hosting) {
    window.HIP.aop.pointCut('hi-http', 'invoke', function (httpInvokeFn: Function) {
      return function (this: IHIHTTP, httpPayload: unknown) {
        const sessionConf: ISessionModuleConfiguration =
          ahp.session.configuration || ({} as ISessionModuleConfiguration);
        const cookie = CookieServant.getCookie(sessionConf.cookie_token_key);

        if (sessionConf.header_token_key && cookie) {
          this.headers = {
            ...this.headers,
            [sessionConf.header_token_key]: cookie
          };
        }

        return httpInvokeFn.call(this, httpPayload);
      };
    });
  }
}

export const tokenCookieSessionStrategy = new TokenCookieSessionStrategy();
